import React, { useEffect, useState } from 'react';

import { formatPhoneNumber } from '@eika-infrastruktur/format';

import { EikaModal } from '../../../components/EikaModal';
import { useUpdateGeneralManager } from '../../../fetchHooks/useContact';
import type { GeneralManager } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import UpdateGeneralManagerModalBody from './UpdateGeneralManagerModalBody';

import './UpdateGeneralManagerModal.scss';

type Props = {
    open?: boolean;
    setOpen: React.Dispatch<boolean>;
    generalManager?: GeneralManager;
    afterUpdate: () => void;
};

export default ({ open = false, setOpen, generalManager, afterUpdate }: Props) => {
    const translated = useTranslation();
    const emailState = useState(generalManager?.email?.value);
    const [, setEmail] = emailState;
    const mobileState = useState(formatPhoneNumber(generalManager?.phoneNumber));
    const [, setMobile] = mobileState;
    const { mutate: update, reset, isSuccess, isPending, error } = useUpdateGeneralManager({ onSuccess: afterUpdate });

    useEffect(() => {
        setEmail(generalManager?.email?.value);
        setMobile(formatPhoneNumber(generalManager?.phoneNumber));
    }, [generalManager, setEmail, setMobile]);

    const resetStates = () => {
        reset();
        resetStates();
        setEmail(generalManager?.email?.value);
        setMobile(formatPhoneNumber(generalManager?.phoneNumber));
    };

    return (
        <EikaModal
            id="update-general-manager"
            open={open}
            setOpen={setOpen}
            onClose={resetStates}
            timeOut={isSuccess ? 2000 : undefined}
            size="wide"
            title={!error && !isSuccess ? translated.companyInfo.editCompanyInfo : undefined}
            contentShouldStretch
        >
            <UpdateGeneralManagerModalBody
                id={generalManager?.id}
                emailState={emailState}
                mobileState={mobileState}
                onSubmit={(id, payload) => update({ id, ...payload })}
                isLoading={isPending}
                isSuccess={isSuccess}
                error={error}
                reset={resetStates}
            />
        </EikaModal>
    );
};
